// **  Initial State
const initialState = {}
  
  const License = (state = initialState, action) => {
    switch (action.type) {
      case 'UPDATE_LICENSE':
        return action.data
    //   case 'LOGOUT':
    //     const obj = { ...action }
    //     delete obj.type
    //     return { ...state, userData: {}, ...obj }
      default:
        return state
    }
  }
  
  export default License
  